import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { FileText } from 'lucide-react';
import { formatDate } from '../../lib/utils';

export const DriveFilePickerDialog = ({ open, onOpenChange, files, onAttach }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-3xl">
      <DialogHeader>
        <DialogTitle>Attach Document from Google Drive</DialogTitle>
      </DialogHeader>
      <div className="space-y-2 max-h-96 overflow-y-auto">
        {files.length === 0 ? (
          <p className="text-center text-muted-foreground py-8">No documents found in Drive</p>
        ) : (
          files.map((file) => (
            <Card
              key={file.id}
              className="p-4 hover:bg-muted cursor-pointer transition-colors"
              onClick={() => onAttach(file)}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <FileText className="h-5 w-5 text-muted-foreground" />
                  <div>
                    <p className="font-medium">{file.name}</p>
                    <p className="text-xs text-muted-foreground">
                      {file.modifiedTime ? formatDate(file.modifiedTime) : ''}
                    </p>
                  </div>
                </div>
                <Button size="sm" variant="ghost">Select</Button>
              </div>
            </Card>
          ))
        )}
      </div>
    </DialogContent>
  </Dialog>
);
